import { contractHref, EVIDENCE, type EvidenceLabel } from '../lib/evidence';
import { Footer } from './Footer';
import { Header } from './Header';

const LABEL_TEXT: Record<EvidenceLabel, string> = {
  measured: 'read from chain or our indexer',
  modeled: 'the fee curve applied to unchanged historical trades',
  external: 'reported by a named third party, not measured by us',
  planned: 'not built yet',
};

/** /evidence: the reviewer evidence table, one row per judging criterion. */
export function EvidencePage() {
  return (
    <>
      <Header home="/" />
      <main>
        <section className="section" id="evidence">
          <h2>Reviewer evidence</h2>
          <p className="table-intro">Each judging criterion, from the platform's four (Smart Contract Quality, Product-Market Fit, Innovation and Creativity, Real Problem Solving) and the terms (use of Arbitrum technology, presentation quality), mapped to the demo step that shows it, the contracts with explorer links, the source file or commit, its limitation, and a label. Addresses as recorded on 23 September 2026; the mainnet and testnet v2 contracts were broadcast from product commit 98f8b45.</p>
          <p className="fineprint">Labels: {(Object.keys(LABEL_TEXT) as EvidenceLabel[]).map((l, i) => <span key={l}>{i ? '; ' : ''}<span className={`label ${l}`}>{l}</span>: {LABEL_TEXT[l]}</span>)}. StockVerifier proves factory provenance, not backing, redemption or safety. BellConfig parameters change through a 24 hour timelock.</p>
          <div className="table-scroll">
            <table className="basis evidence-table">
              <colgroup><col style={{ width: '27%' }} /><col style={{ width: '17%' }} /><col style={{ width: '17%' }} /><col style={{ width: '14%' }} /><col style={{ width: '18%' }} /><col style={{ width: '7%' }} /></colgroup>
              <thead><tr><th>Criterion and claim</th><th>Demo step</th><th>Contracts</th><th>Source</th><th>Limitation</th><th>Label</th></tr></thead>
              <tbody>
                {EVIDENCE.map((r) => (
                  <tr key={r.criterion}>
                    <td><strong>{r.criterion}</strong><span className="muted">{r.rubric === 'platform' ? 'Platform criterion. ' : 'Terms criterion. '}</span>{r.claim}</td>
                    <td>{r.demo}</td>
                    <td>{r.contracts.length === 0 ? <span className="muted">none</span> : r.contracts.map((c) => (
                      <div key={c.addr + c.name}>{c.name} <span className="muted">({c.chainId})</span><br /><a href={contractHref(c)} rel="noopener"><code>{c.addr.slice(0, 10)}…{c.addr.slice(-6)}</code></a></div>
                    ))}</td>
                    <td>{r.sources.map((s) => <div key={s.href + s.text}><a href={s.href} rel="noopener">{s.text}</a></div>)}</td>
                    <td>{r.limitation}</td>
                    <td>{r.labels.map((l) => <div key={l} className={`label ${l}`}>{l}</div>)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
